
export const pricing = {
  'request.pricing': 'Pyydä hintatietoja',
  'view.pricing': 'Näytä hinnat',
  'product.pricing': 'Tuotteen hinnoittelu',
};
